// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___8_R_x","action":"styles__action___3f-eu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RepairWizard/components/ModalProblemSolved/styles.css
// module id = 2780
// module chunks = 0